import script from "./myCard.vue?vue&type=script&setup=true&lang=js"
export * from "./myCard.vue?vue&type=script&setup=true&lang=js"

import "./myCard.vue?vue&type=style&index=0&id=87ca904e&scoped=true&lang=scss"
import "./myCard.vue?vue&type=style&index=1&id=87ca904e&lang=css"

import exportComponent from "/var/jenkins_home/workspace/fbdnextui_staging-v3/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-87ca904e"]])

export default __exports__